<template>
  <div class="contact_us">
    <Header></Header>

    <div v-show="overlayerFlag1 || overlayerFlag2" class="overlayer">
      <div class="modal">
        <span class="close" @click="close1"></span>
        <div v-show="overlayerFlag1" class="contents" id="contents">
          <p class="name">{{currentJob.name}}</p>
          <div class="conrtent1">
            <p class="text" v-for="item in currentJob.contents1">
              {{item}}
            </p>
          </div>
          <div class="conrtent2">
            <p class="text" v-for="item in currentJob.contents2">
              {{item}}
            </p>
          </div>
        </div>
        <p v-show="overlayerFlag1" class="tips">投递简历：hr@raipeng.com</p>

        <div v-show="overlayerFlag2">
          <div class="state">
            <p class="message" v-html="message"></p>
            <button @click="close">确定</button>
          </div>
        </div>
      </div>
    </div>

    <Banners :banner="banner"></Banners>

    <div class="part1">
      <p class="title">加入瑞鹏</p>
      <img :src="imgUrl1" alt="" class="img1" @click="noClick">
      <p class="text">如果你是想这样的人，如果你想成为这样的人</p>
      <img :src="imgUrl2" alt="" class="img2" @click="noClick">
      <p class="text" style="margin-bottom: 0.8rem;">瑞鹏期待您的加入！</p>

      <p class="title">职位信息</p>
      <ul class="jobs">
        <li v-for="job,index in jobs">
          <div class="name" @click="clickJob(index)"><i class="icon_right_arrow"></i><span>{{job.name}}</span></div>
        </li>
      </ul>

      <div class="form">
        <input type="text" id="name" class="name" placeholder="姓名" v-model="form.name">
        <input type="number" id="tel" class="tel" placeholder="手机" v-model="form.tel">
        <input type="text" id="email" class="email" placeholder="邮箱" v-model="form.email">
        <input type="text" id="problem" class="problem" placeholder="问题描述" v-model="form.problem">
        <textarea class="remark" id="remark" placeholder="请在此处写下详情的问题描述" v-model="form.remark"></textarea>
        <button class="submit" @click="submit">提交</button>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/mComponents/Header"
  import Banners from "@/mComponents/Banners"
  import Footer from "@/mComponents/Footer"

  export default {
    name: 'Contact_Us',
    data() {
      return {
        banner: require("@/assets/imgs/mobile/banner-05.png"),
        imgUrl1: require("@/assets/imgs/mobile/img-contact-us-activity.png"),
        imgUrl2: require("@/assets/imgs/mobile/img-textcloud.png"),
        currentJob: {},
        jobs:[
          {
            name:"爬虫工程师",
            contents1:["岗位职责", "1. 负责公司爬虫系统的开发及维护；"," 2. 负责优化抓取程序的监控和报警，能够快速解决问题；"," 3. 参与爬虫核心算法和策略优化，熟悉采集系统的调度策略；"," 4. 富有激情，勇于挑战，具备优秀的学习能力和解决问题能力。"],
            contents2:["任职资格"," 1. 计算机. 电子信息. 软件工程. 数学等相关专业本科211及以上学历，2年以上Python工作经验；"," 2. 工作细致. 责任心强，具备较强的学习能力及理解能力，有良好的沟通能力和团队协作能力；"," 3. 熟悉爬虫原理，熟悉常见的反爬虫技术，有爬虫相关项目开发经验者优先；"," 4. 理解http，熟悉html DOM xpath 精通scrapy优先；"," 5. 有大规模数据处理. 数据挖掘. 信息提取等经验者优先。"]
          },
          {
            name:"数据分析师",
            contents1:["岗位职责","1. 围绕内容质量. 风险. 效率等方面挖掘业务问题，通过海量数据的挖掘和分析，形成报告为业务部门决策提供分析方案和出行动建议；","2. 建立并持续完善业务数据的统计分析模型，确保其实用性及可衡量性；","3. 提升产品数据化能力，与相研发关团队协作并推动数据产品的落地。"],
            contents2:["任职资格","1. 1-3年数学. 计算机. 统计学专业本科211及以上学历；","2. 精通SQL. Excel. PPT，具备扎实的统计与数学知识，掌握量化分析方法，掌握R/Python/SPSS/SAS任何一种优先；","3. 能从海量数据中提炼核心结果，参加过完整的数据分析项目并有成功案例者优先；","4. 良好的逻辑思维能力，清晰的沟通表达能力，很强的学习能力，良好的团队合作精神。"]
          },
          {
            name:"大数据商务经理",
            contents1:["岗位职责","1. 主动开发客户，拓展客户合作渠道；","2. 熟悉软件产品及行业动态，能够独立进行大数据软件及解决方案的讲解和演示；","3. 跟进销售合同，及时完成签约和收款，完成销售业绩的考核；","4. 日常的客户维护工作，收集市场动态和客户需求；","5. 负责宣讲和推介公司的平台和方案，参与客户的投标和相关咨询；","6. 持续关注互联网相关领域的进展，为公司技术研发提供积极思路。"],
            contents2:["任职资格","1. 本科211及以上学历，计算机软件. 市场营销专业为佳；","2. 熟悉大数据行业，在大数据应用领域具备一定的行业经验和客户资源；","3. 擅长商务谈判，能为客户编写项目方案；","4. 个性开朗. 逻辑思维能力强. 沟通能力优秀. 有团队合作精神. 能受较大工作压力，可以适应经常出差。"]
          },
          {
            name:"资深JAVA工程师",
            contents1:["岗位职责","1. 负责业务系统建设，需求把控. 系统设计. 功能开发，把纷繁的业务需求拆解细化并实施；","2. 以快速解决业务需求为第一要义，无情的推进自动化，用技术提高生产力，持续优化系统架构；","3.优化系统性能，保证服务器质量和性能。"],
            contents2:["任职资格","1.本科211及以上学历，扎实的计算机专业基本功；","2.3年以上Java开发经验，精通Java及面向对象设计开发，对部分Java技术有深入研究，研究过优秀开源软件的源码并有心得者优先；","3.熟悉常见设计模式，精通Spring，MyBatis等流行开源框架；","4.精通MySQL应用开发，熟悉数据库原理和常用性能优化技术，以及NoSQL. Queue 的原理. 使用场景以及限制。"]
          },
          {
            name:"数据挖掘工程师",
            contents1:["岗位职责","1. 围绕内容质量. 风险. 效率等方面挖掘业务问题，通过海量数据的挖掘和分析，形成报告为业务部门决策提供分析方案和出行动建议；","2. 建立并持续完善业务数据的统计分析模型，确保其实用性及可衡量性；","3. 提升产品数据化能力，与相研发关团队协作并推动数据产品的落地。"],
            contents2:["任职资格","1. 1-3年数学. 计算机. 统计学专业本科211及以上学历；","2. 精通SQL. Excel. PPT，具备扎实的统计与数学知识，掌握量化分析方法，掌握R/Python/SPSS/SAS任何一种优先；","3. 能从海量数据中提炼核心结果，参加过完整的数据分析项目并有成功案例者优先；","4. 良好的逻辑思维能力，清晰的沟通表达能力，很强的学习能力，良好的团队合作精神。"]
          },
          {
            name:"大数据建模工程师",
            contents1:["岗位职责"," 1.大数据BI设计和开发海量数据收集. 传输系统的设计和开发；"," 2.流式实时和离线批处理数据分析平台的设计和开发，多维度数据查询支持；"," 3.数据仓库及数据平台建设；"," 4.支持游戏发行部门的运营，产品，研发等各方面的数据分析。"],
            contents2:["任职资格","  1. 统计学. 数学. 计算机等数据挖掘专业方向相关专业本科211及以上学历；"," 2. 有3年以上数据分析经验，有游戏数据分析经验者优先；"," 3. 熟悉JAVA MapReduce. SQL等语言，熟悉HadoopStormHBaseHiveKafka；"," 4. 熟练使用数理统计. 数据分析. 数据挖掘工具软件；"," 5. 有一定的数据统计和数据挖掘专业知识，具备利用数据分析解决业务问题的能力。"]
          },
          {
            name:"资深算法工程师",
            contents1:["岗位职责","1. 结合业务场景，对海量用户行为数据进行深度数据分析与统计，挖掘用户行为模式，为运营决策提供数据支持；","2. 具备很强的探索创新能力，能够以独创性思维进行算法研究；","3. 逻辑思维清晰严谨，有较强的学习能力和钻研精神；","4. 知识面宽，思维灵活，能应对处理各种复杂问题；","5. 优秀的团队合作与组织能力，踏实上进责任心强，抗压能力强。"],
            contents2:["任职资格"," 1. 计算机. 电子信息. 软件工程. 数学等相关专业本科211及以上学历；"," 2. 工作细致. 责任心强，具备较强的学习能力及理解能力，有良好的沟通能力和团队协作能力；","3. 具备扎实的数字信号处理和数字图像处理基础；","4. 熟练掌握一种或多种脚本语言编程,例如perl,lua,tcl等。 "]
          },
          {
            name:"高级算法工程师",
            contents1:["岗位职责","1. 结合业务场景，对海量用户行为数据进行深度数据分析与统计，挖掘用户行为模式，为运营决策提供数据支持；"," 2. 基于采集数据. 用户基础属性数据. 用户行为数据等建立并持续优化用户标签体系与用户画像模型；"," 3. 负责基于机器学习算法，进行标签挖掘，特征开发，用户分类，表示学习；"," 4. 其他数据挖掘算法优化和实现。"],
            contents2:["任职资格","1. 计算机. 统计. 数学相关专业硕士及以上学历，3年以上的机器学习算法研发经验；"," 2. 具有优秀的逻辑思维能力，对解决挑战性问题充满热情，善于分析/解决问题； ","3. 熟悉掌握 Spark/Hadoop 优先，熟悉Deep Learning及掌握TensorFlow，Caffe，Python等其一者优先。"]
          },
          {
            name:"软件测试工程师",
            contents1:["岗位职责","1. 参与公司产品功能模块的需求制定；","2. 根据需求编写嵌入式系统软件功能模块的测试用例；","3. 根据测试用例编写相应测试代码，完成软件功能模块测试，并完成测试报告；","4. 协助开发工程师定位具体问题；","5. 协助系统测试工程师进行系统集成测试执行。"],
            contents2:["任职资格","1. 本科211及以上学历；"," 2. 3年以上相关工作经验；","3. 精通软件功能测试流程；","4. 精通shell脚本，具备编写自动化测试脚本的能力；","5. 熟悉linux操作系统，熟练使用linux操作系统的系统调用；","6. 熟悉c语言，可使用c语言编写简单测试程序；","7. 具备用自动化工具对测试数据筛选处理的能力；","8. 接受新事物能力强，工作积极主动，责任心强，有团队意识；","9. 良好的沟通表达能力。"]
          },
          {
            name:"新媒体运营/DSP",
            contents1:["岗位职责","1. 根据领导安排，负责微信. 微博. 博客等自媒体运营；","2. 与用户/粉丝做好互动，提高用户/粉丝活跃度，对所负责自媒体平台用户网络行为进行分析总结，提高用户黏性；","3. 独立策划活动. 内容进行推广，并跟踪推广效果，监测总结，调整策略；","4. 紧跟微信发展趋势，广泛关注标杆性公众号，积极探索微信运营模式；","5. 充分了解用户需求，收集用户反馈，分析用户行为。"],
            contents2:["任职资格","1. 本科211及以上学历，有3年以上自媒体运营或互联网运营经验者优先；","2. 熟悉掌握自媒体运营后台工具，能够独立完成新媒体营销策划方案撰写；","3. 有较强的网络营销意识，热爱互联网. 移动互联网行业，熟悉粉丝营销方法，并有成功案例者优先。"]
          },
          {
            name:"html5前端工程师",
            contents1:["岗位职责","1. 负责移动端H5页面的开发. 维护；","2. 参与项目过程中的需求分析. UI评审. 编码. 调试. Bug修复等；","3. 深入分析和解决前端遇到的各种技术. 性能. 跨终端兼容问题，保证页面响应性能和执行效率；","4. 参与前端架构设计和核心代码的实现，实现H5与原生之间良好的交互，实现跨平台的使用。"],
            contents2:["任职资格","1. 本科211及以上学历；","2. 3年及以上Web前端开发经验，深刻理解Web标准，对前端性能. 可访问性. 可维护性有较深的理解；","3. 精通HTML/CSS/JS等，熟练掌握React/Vue等主流js框架，对前端工程化和模块化有一定的了解；","4. 掌握前端自动化测试技术，评估. 分析并优化前端性能；","5. 具备良好的沟通协调能力和团队精神。"]
          },
          {
            name:"大数据产品经理",
            contents1:["岗位职责 ","1. 跟踪大数据市场动向，市场竞争对手分析，设计和提出产品的创新应用；","2. 研究和规划数据产品的功能. 服务及所需的业务流程，把握产品定位；","3.跟踪. 分析. 挖掘产品的客户需求，并能结合集团整体的业务规划，进行需求评估；","4. 跟踪协调进度，把握质量，协调交付。"],
            contents2:["任职资格"," 1.数学. 统计. 通信和计算机相关专业本科211及以上学历；"," 2. 丰富的产品管理经验，从需求的确认. 产品的原型，PRD的撰写. 资源的协调，到产品上线后的跟进与项目管理；","3. 在金融风控. 标签画像. 精准营销等一个或多个领域有深厚的经验积累和工作背景，主导过相关产品设计；","4.5年以上产品经理或产品设计工作经验，可独立进行业务分析. 产品规划和管理。"]
          },
        ],
        overlayerFlag1: false,
        overlayerFlag2: false,
        message: "提交成功！",
        form: {
          name: "",
          tel: "",
          email: "",
          problem: "",
          remark: ""
        }
      }
    },
    components: {
      Header,Banners,Footer,
    },
    created() {
      window.scrollTo(0,0);
      this.currentJob = this.jobs[0]
      this.$store.commit('changeNavsM', 'mContact_Us')
    },
    methods: {
      noClick() {
        return false;
      },
      submit() {
        if(this.form.name == "") {
          this.overlayerFlag2 = true
          this.message = "<span style='color: red;font-size: 0.44rem;margin: 0 0.1rem;'>姓名</span>不能为空 !"
          return false
        }
        if(this.form.tel == "") {
          this.overlayerFlag2 = true
          this.message = "<span style='color: red;font-size: 0.44rem;margin: 0 0.1rem;'>手机号</span>不能为空 !"
          return false
        }
        if(this.form.tel.length != 11) {
          this.overlayerFlag2 = true
          this.message = "<span style='color: red;font-size: 0.44rem;margin: 0 0.1rem;'>手机号</span>必须11位 !"
          return false
        }
        if(this.form.email == "") {
          this.overlayerFlag2 = true
          this.message = "<span style='color: red;font-size: 0.44rem;margin: 0 0.1rem;'>邮箱</span>不能为空 !"
          return false
        }
        if(this.form.problem == "") {
          this.overlayerFlag2 = true
          this.message = "<span style='color: red;font-size: 0.44rem;margin: 0 0.1rem;'>问题描述</span>不能为空 !"
          return false
        }

        this.message = "提交<span style='color: green;font-size: 0.44rem;margin: 0 0.1rem;'>成功</span>!"
        this.overlayerFlag2 = true;
        this.form.name = ""
        this.form.tel = ""
        this.form.email = ""
        this.form.problem = ""
      },
      clickJob(index) {
        var vm = this
        vm.overlayerFlag1 = true;
        vm.currentJob = vm.jobs[index]
        setTimeout(function() {
          document.getElementById('contents').scrollTop = 0;
          // vm.stop()
        },10)
      },
      close() {
        this.overlayerFlag2 = false;
        // this.move()
      },
      close1() {
        this.overlayerFlag1 = false;
        this.overlayerFlag2 = false;
        // this.move()
      },
      // stop(){
      //   var mo=function(e){e.preventDefault();};
      //   document.body.style.overflow='hidden';
      //   document.addEventListener("touchmove",mo,false);//禁止页面滑动
      //
      // },
      // move(){
      //   var mo=function(e){e.preventDefault();};
      //   document.body.style.overflow='';//出现滚动条
      //   document.removeEventListener("touchmove",mo,true);//页面可以滑动
      // }
    },
    mounted() {
      var vm = this;
      $(".overlayer").on("click", function(e) {
        var _con = $('.modal '); // 设置目标区域
        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
          vm.overlayerFlag1 = false;
          vm.overlayerFlag2 = false;
          // vm.move()
        }
      })
      setTimeout(function() {
        window.onscroll = function() {
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          if(scrollTop>30) {
            $(".icon-m-up").css("display","block")
            $(".top").addClass("active")
          } else {
            $(".icon-m-up").css("display","none")
            $(".top").removeClass("active")
          }
        }
      },100)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss" type="text/scss">
  .overlayer {
    position:fixed;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    opacity: 1;
    z-index: 9999;
    .modal {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      background-color: #fff;
      width: 6.5rem;
      overflow: hidden;
      border-radius: 3px;
      z-index: 10000;

      .close {
        position: absolute;
        background: url("../../assets/imgs/mobile/close.png") no-repeat center center;
        background-size: 0.3rem 0.3rem;
        width: 0.55rem;
        height: 0.55rem;
        display: block;
        top: 0.2rem;
        right: 0.1rem;
        z-index: 10001;
      }

      .contents {
        padding: 0.1rem 0.6rem 0.2rem;
        overflow-y: auto;
        position: relative;
        -webkit-overflow-scrolling: touch;
        .name {
          font-size:0.3rem;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(0,0,0,1);
          line-height:0.36rem;
          margin: 0.2rem 0;
          box-sizing: border-box;
        }
        .text {
          font-size:0.24rem;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(0,0,0,1);
          line-height:0.35rem;
        }
        .conrtent1 {
          margin-bottom: 0.2rem;
        }
      }
      .tips {
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        font-size:0.3rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,156,255,1);
        border-top:0.01rem solid rgba(210,211,213,1);
      }
      .state {
        padding: 0.3rem 0 0.5rem;
        .message {
          text-align: center;
          font-size:0.3rem;
          font-family:PingFangSC-Medium;
          font-weight:500;
          height: 1rem;
          line-height: 1.2rem;
          opacity: 0.6;
          margin-bottom: 0.3rem;
        }
        button {
          background-color: #0190dc;
          width: 1.5rem;
          height: 0.6rem;
          text-align: center;
          line-height: 0.4rem;
          display: block;
          margin: 0 auto;
          outline: none;
          border: none;
          color: #fff;
          font-size:0.3rem;
          font-family:PingFangSC-Medium;
          font-weight:500;
          border-radius: 6px;
        }
      }
    }
  }
  .contact_us {
    background:rgba(237,237,237,1);

    .clear {
      clear: both;
    }
    .part1 {
      padding: 0.4rem 0 0.45rem;
      .title {
        font-size:0.4rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-bottom: 0.4rem;
      }
      .img1 {
        width:6.94rem;
        height:3.82rem;
        display: block;
        margin: 0 auto 0.8rem;
      }
      .text {
        font-size:0.24rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height: 0.4rem;
        text-align: center;
      }
      .img2 {
        width: 3.15rem;
        height: 3.85rem;
        display: block;
        margin: 0.2rem auto;
      }
      ul.jobs {
        background-color: #fff;
        margin: 0 0.4rem 0.4rem;
        box-sizing: border-box;
        padding: 0.3rem 0;
        li {
          .name {
            font-size:0.26rem;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(0,113,183,1);
            height: 0.6rem;

            .icon_right_arrow {
              width: 12px;
              height: 0.5rem;
              background: url("../../assets/imgs/right-arrow1.png") no-repeat center;
              background-size: 12px 12px;
              display: inline-block;
              margin-left: 0.6rem;
              margin-right: 5px;
            }
            span {
              vertical-align: top;
              display: inline-block;
              line-height: 0.5rem;
            }
          }
        }
      }
      .form {
        input {
          width: 6.7rem;
          height: 0.6rem;
          margin: 0 auto 0.4rem;
          padding: 0.15rem;
          line-height: 0.3rem;
          box-sizing: border-box;
          display: block;
          border:1px solid rgba(204,204,204,1);
          border-radius:4px;
          font-size: 0.24rem;
          outline: none;
        }
        textarea {
          font-size: 0.24rem;
          width: 6.7rem;
          height: 2.2rem;
          padding: 0.15rem;
          display: block;
          margin: 0 auto 0.4rem;
          box-sizing: border-box;
          border:1px solid rgba(204,204,204,1);
          border-radius:4px;
          outline: none;
        }
        button.submit {
          width: 6.7rem;
          height: 0.8rem;
          background:rgba(0,102,235,1);
          border-radius:8px;
          outline: none;
          border: none;
          display: block;
          margin: 0 auto;
          color: #fff;
          font-size: 0.34rem;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/Mobile/Contact_Us.vue